export default "__VITE_ASSET__CJJg81KU__"